import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { PasswordInput } from "@/components/PasswordInput";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const user = await login(username, password);
      const redirect = location.state?.from || (user.role === "admin" ? "/admin" : user.role === "collector" ? "/dashboard/collector" : user.role === "company" ? "/dashboard/company" : "/search");
      navigate(redirect);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="container-x py-20 max-w-md" data-testid="login-page">
      <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#CC5A3A] mb-3">Welcome back</div>
      <h1 className="font-heading text-3xl text-[#1E3F33] font-semibold">Sign in</h1>
      <p className="text-[#5C6B64] mt-2">Sign in to your <span className="text-[#B91C1C] font-medium">Screening Services Mobile</span> account.</p>
      <form onSubmit={onSubmit} className="mt-10 space-y-5">
        <div>
          <label className="label-soft">Username</label>
          <input
            data-testid="login-username-input"
            required
            className="input-soft"
            value={username}
            onChange={(e)=>setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
          />
        </div>
        <div>
          <label className="label-soft">Password</label>
          <PasswordInput
            testId="login-password-input"
            toggleTestId="login-password-toggle"
            required
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        {err && <div data-testid="login-error" className="text-sm text-[#E63946]">{err}</div>}
        <button data-testid="login-submit-button" disabled={busy} className="btn-primary w-full">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="text-sm text-[#5C6B64] mt-4">
        <Link to="/recover" data-testid="login-recover-link" className="text-[#CC5A3A] font-medium">Forgot username or password?</Link>
      </p>
      <p className="text-sm text-[#5C6B64] mt-2">
        New here? <Link data-testid="login-to-register" to="/register" className="text-[#CC5A3A] font-medium">Create an account</Link>
      </p>
    </div>
  );
}
